// Environment
export const initialEdges = {
    edges: [
        { id: 'e1-2', source: '1', target: '2', style: { strokeWidth: 3, stroke: '#7b3fc0' }, markerEnd: { type: 'arrowclosed', color: '#7b3fc0' } },
    ]
};

export const edgesReducer = (state = initialEdges, action) => {
    switch (action.type) {
        case "SET_EDGES":
            return {
                ...state,
                edges: action.edges
            }
        default:
            return state;
    }
};
